<div [id]="'survey_card-'+ surveyData?.mi" class="p-sm-4 p-md-4 p-3" [ngClass]="{'reward_gradient' : surveyData?.pty?.rpts > 0, 'survey-card-container' : surveyData?.sn?.mcnt == false }">
  <div class="position-relative hover-showing">
    <div class="position-absolute w-100 h-100 masking-card" *ngIf="surveyData?.sn?.mcnt">
      <app-product-masking-card [content_visibility]=""  [communityVisible]="surveyData?.sn?.mcnt"></app-product-masking-card>
    </div>
  <div class="row">
    <div class="col-9 d-flex flex-column">
      <p class="heading-4 mb-2 survey-card-heading">
        <span [id]="'survey_card_heading-'+ surveyData?.mi" class="cursor-pointer " (click)="goToDetail()">{{surveyData?.ttl}}</span>
      </p>
      <div class="mb-3 secondary-paragraph">
        <span [id]="'survey_card_speciality-'+ speciality.n " class="color-grey-500 mr-12 cursor-pointer d-inline-block"
          *ngFor="let speciality of surveyData?.sptags | slice: 0: 3"
          (click)="getSpecialty(speciality)">#{{speciality.n}}
        </span>
        <span *ngIf="surveyData?.sptags?.length > 3" (click)="goToDetail()" class="cursor-pointer">
          <span>+{{surveyData?.sptags?.length - 3}}{{mls.languageText.survey_list.key11}}</span>
        </span>

        <span *ngIf="isPopup" class="specialty-popup row mx-2">
          <p class="text-right col-1 order-2 p-0">
            <span (click)="closeSpecialtyPopup()" class="cursor-pointer "><img width="16"
                src="assets/themes/icons/cancel.svg" alt="cross-icon"></span>
          </p>
          <div class="col-11 p-0">
            <span (click)="getSpecialty(speciality)" class="pr-2 cursor-pointer d-inline-block"
              *ngFor="let speciality of surveyData?.sptags">#{{speciality.n}}</span>
          </div>
        </span>
      </div>
      <div class="row sponsor">
        <div class="col-12">
          <span class="sponsor-logo"
            [ngClass]="{'cursor-pointer':  fcs.navigateToSponsorDetail(surveyData?.sn?.code, surveyData?.sn?.n)}">
            <img class="rounded-circle mr-2"
              [src]="fileSignedUrls[surveyData?.sn?.l] ? fileSignedUrls[surveyData?.sn?.l] : surveyData?.sn?.l"
              (click)="channelDetail(surveyData?.sn?.code)" onerror="this.src='assets/images/icons/sponsor-default.svg'"
              alt="sponsor-logo" />
          </span>
          <span class="secondary-paragraph">
            <span class="color-grey-500">{{mls.languageText.survey_card.key6}} </span>
            <span [id]="'powered_by-'+surveyData?.sn?.n" class="color-grey-500 d-inline-block cursor-pointer" innerHTML="{{surveyData?.sn?.n}}"
              (click)="channelDetail(surveyData?.sn?.code)"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="col-3 pl-0 cursor-pointer" (click)="goToDetail()">
      <div class="survey-banner-container">
        <img class="survey-banner" [src]="fileSignedUrls[surveyData?.bcode] ? fileSignedUrls[surveyData?.bcode] : null"
          onerror="this.src='assets/themes/icons/survey-default-placeholder.png'" alt="banner-image" width="178"
          height="108">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 d-flex flex-column flex-lg-row mt-2">
      <div class="secondary-paragraph pb-md-0 pb-3">
        <!-- date of expire -->
        <div class="d-flex align-items-center">
          <span>
            <img width="20" src="assets/themes/icons/survey_clock.svg" class="mr-2" alt="clock">
          </span>
          <span *ngIf="productType !== surveyStatus.COMPLETED" class="color-grey-500">
            <span>{{mls.languageText.survey_card.key8}}:</span>
            <span [id]="'survey_card_expire-'+surveyData.edms" class="color-grey-700">{{surveyData?.edms| formatDate:'DD MMM YYYY'}}</span>
          </span>
          <span *ngIf="productType === surveyStatus.COMPLETED" class="color-grey-500">
            <span>{{mls.languageText.survey_card.key7}}:</span>
            <span class="color-grey-700">{{surveyData?.lsdms| formatDate:'DD MMM YYYY'}}</span>
          </span>
        </div>
        <!-- reward points available  -->
        <div class="mt-3 reward_points rounded-3" *ngIf="surveyData?.pty?.rpts > 0">
          <span class="border border-dashed p-1 rounded-3 d-flex align-items-center ">
            <span><img width="32px" [src]="countrySupportService.userCountryRelatedData.currency.icon" alt="docquity-reward-coins-icon"
                class="mx-2"></span>
            <span class="heading-3">{{surveyData?.pty?.rpts}}</span>
            <span class="text-red-8c5e3a pl-2 heading-4">{{countrySupportService.userCountryRelatedData.currency.code}}</span>
          </span>
        </div>
        <!-- precentage completed draft -->
        <div *ngIf="productType === surveyStatus.DRAFT" class="pt-3">
          <span class="color-error">{{100 - surveyData?.prg}}% left</span>
          <div class="progress-bar-container">
            <div class="progress-view">
              <span class="progress-status" [style.width.%]="surveyData?.prg"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-auto clearfix d-flex align-items-end">
        <button *ngIf="!isPublicSource && surveyData?.pty?.shr" (click)="productShare()"
          class="btn-design small outline mr-12 padding-18">
          <span class="d-flex align-items-center">
            <img src="assets/themes/icons/survey_share.svg" alt="share" />
            <span class="ml-1">
              {{mls.languageText.survey_card.key1}}
            </span>
          </span>
        </button>

        <button (click)="goToDetail()"
          *ngIf="((surveyData?.pty?.retkl === 0) && productType === surveyStatus.COMPLETED) || productType === surveyStatus.ALL"
          class="btn-design small outline">
          {{mls.languageText.survey_card.key2}}
        </button>

        <button (click)="continueToSurvey()" *ngIf="productType === surveyStatus.DRAFT"
          class="btn-design small outline padding-18">
          {{mls.languageText.survey_card.key3}}
        </button>

        <button (click)="goToRetake()" *ngIf="(surveyData?.pty?.retkl !== 0) && productType === surveyStatus.COMPLETED"
          class="btn-design small outline">
          {{mls.languageText.survey_card.key4}}
        </button>
      </div>
    </div>
  </div>
</div>
</div>

<app-confirm-card *ngIf="isExpired || surveyService.isExpired" [confirmPopup]="isExpired || surveyService.isExpired"
  banner="assets/themes/images/respondents.svg" [heading]="mls?.languageText?.survey_questionnaire?.key61"
  [paragraph]="mls?.languageText?.survey_questionnaire?.key62"
  [confirmText]="mls?.languageText?.survey_questionnaire?.key63" (confirmAction)="closeExpiryModal()">
</app-confirm-card>

<app-confirm-card *ngIf="surveyService.maxPopup" [confirmPopup]="surveyService.maxPopup"
  banner="assets/themes/images/respondents.svg" [heading]="mls?.languageText?.survey_questionnaire?.key47"
  [paragraph]="mls?.languageText?.survey_questionnaire?.key62"
  [confirmText]="mls?.languageText?.survey_questionnaire?.key49" (confirmAction)="closeMaxRespondantModal()">
</app-confirm-card>
